import { render, staticRenderFns } from "./_Bank.vue?vue&type=template&id=36b07eae&scoped=true"
import script from "./_Bank.vue?vue&type=script&lang=js"
export * from "./_Bank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b07eae",
  null
  
)

export default component.exports